import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../login/auth.service';
import { CabecalhoService } from '../cabecalho/cabecalho.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService); // Injetando o AuthService
  const cabecalho = inject(CabecalhoService);
  const router = inject(Router); // Injetando o Router

  cabecalho.alterarAmbiente('eventos');

  if (authService.isLoggedIn()) {
    return true; // Permite o acesso se o usuário estiver logado
  } else {
    router.navigate(['/eventos/entrar-conta'], { queryParams: { returnUrl: state.url } }); // Redireciona para login se não autenticado
    return false; // Bloqueia o acesso
  }

};
